import { LuFilter } from '@react-icons/all-files/lu/LuFilter'
import React from 'react'

import { IconButton } from 'components/ds'

type Props = React.ComponentPropsWithoutRef<typeof IconButton> & {
  // Highlight the icon when the column has an active filter applied.
  isFiltered?: boolean
  /** Replaces the funnel, e.g. the globe for Source. */
  icon?: React.ReactNode
}

/**
 * Shared funnel trigger for column-header filters (Source, Appears on, …). Kept
 * as a forwardRef so it composes as the child of a Radix `Popover.Trigger` /
 * `DropdownMenu.Trigger` (which clone it via `asChild`).
 */
export const ColumnHeaderFilterIcon = React.forwardRef<
  HTMLButtonElement,
  Props
>(({ isFiltered, icon = <LuFilter />, ...props }, ref) => (
  <IconButton
    ref={ref}
    size="1"
    variant="ghost"
    color={isFiltered ? undefined : 'gray'}
    {...props}
  >
    {icon}
  </IconButton>
))

ColumnHeaderFilterIcon.displayName = 'ColumnHeaderFilterIcon'
